import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export const FullscreenLoader = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.4)', // escurecimento leve
        zIndex: 1300, // acima de qualquer conteúdo normal
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress size={50} thickness={5} />
    </Box>
  );
};
